<template>
  <div class="flex flex-col gap-2 mt-10 mb-8">
    <div class="flex items-center justify-between mb-4">
      <h4 class="mb-2">
        {{
          $t("labels.generic", {
            pt: "Objetos",
            en: "Objects",
          })
        }}
      </h4>
      <Button
        :label="$t('labels.generic', { pt: 'Baixar', en: 'Download' })"
        icon="pi pi-download"
        class="p-button-sm btn-primary h-9"
        :loading="btnLoading"
        @click="downloadCSV"
      />
    </div>
    <div class="bg-white rounded-lg border border-gray-300 overflow-auto">
      <div class="w-full p-4 flex justify-end">
        <span class="p-input-icon-right">
          <i
            class="pi pi-search text-h-primary-500 cursor-pointer"
            @click="objectsPaginated()"
          />
          <InputText
            v-model="objectName"
            placeholder="Pesquisar por objetos"
            @keyup.enter="objectsPaginated()"
          />
        </span>
      </div>
      <Table
        :slotData="objects"
        :columns="columns"
        :loading="loader"
        :params="params"
        :filters="filters"
        :hasStatus="false"
        :hasActions="false"
        @onPaginate="paginate($event)"
      >
      </Table>
    </div>
  </div>
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { ObjectsObjectiveStats } from "@/models/stats.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { GoToRoute } from "@/utils/go-to.util";
import saveAs from "file-saver";
import { delay, last, take } from "rxjs";
import { defineAsyncComponent, defineComponent } from "vue";
import { ObjectsService } from "./objects.service";
import { objectsStats } from "./objects.utils";
import { GeneralService as Data } from "../General/general.service";

const Card = defineAsyncComponent(() => import("../../Card/card.vue"));
export default defineComponent({
  name: "objectsStats",
  components: { Card },
  emits: ["onGetCurrentObjective"],
  computed: {
    statsService(): ObjectsService {
      return new ObjectsService();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
    rest(): StatsRest {
      return new StatsRest();
    },
    classroomId(): string {
      return String(localStorage.getItem("objClassroomId"));
    },
  },
  watch: {
    $route(val) {
      if (this.$route.name === "statsObjective") {
        this.objectiveId = val.params.objectiveId;
        this.objectsPaginated();
      }
    },
  },
  data() {
    return {
      columns: objectsStats,
      filters: {
        isCleareable: false,
        name: null,
      } as any,
      actions: [],
      loader: true as boolean,
      btnLoading: false as boolean,
      objectiveId: "" as string,
      courseId: "" as string,
      objectName: undefined as string | undefined,
      params: new QueryParams(),
      objects: [] as ObjectsObjectiveStats,
    };
  },
  mounted() {
    this.courseId = String(this.$route.params.courseId);
    this.objectiveId = String(this.$route.params.objectiveId);
    this.objectsPaginated();
  },
  methods: {
    paginate(event: { page: number; rows: number }): void {
      const params = new QueryParams(event.page, event.rows);
      this.getObjects(params);
    },
    objectsPaginated(): void {
      const page = this.params.page;
      const size = this.params.size;
      const params = new QueryParams(page, size);
      params.nameObject = this.objectName ?? undefined;
      this.getObjects(params);
    },
    getObjects(queryParams: QueryParams): void {
      this.statsService.objects.pipe(take(2), last()).subscribe({
        next: (response: any) => {
          this.loader = false;
          this.objects = response.content;
          this.params.total = response.total;
        },
        error: () => {
          this.loader = false;
        },
      });
      this.statsService.getMaterialsByObjectiveStats(
        this.courseId,
        this.objectiveId,
        queryParams
      );
    },
    downloadCSV(): void {
      this.btnLoading = true;
      this.rest
        .getObjectsByObjectiveStatsCsv(this.courseId, this.objectiveId, {
          classroomId: this.classroomId,
        })
        .pipe(delay(1000))
        .subscribe({
          next: (response) => {
            this.btnLoading = false;
            const blob = new Blob([response], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            saveAs(url, `objects_data.csv`);
          },
          error: () => {
            this.btnLoading = false;
          },
        });
    },
  },
});
</script>
